// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"a5ee0027","844":"42c1e7c6"}[chunkId] + ".chunk.css";
};